export const safeWindow: Partial<Window & typeof globalThis & {
  dataLayer?: any[];
}> = typeof window !== 'undefined' ? window : {};
